import { Crown, Swords } from "lucide-react";

export default function BioCard({ bio }) {
  if (!bio) return null;
  return (
    <div className="glass rounded-3xl p-5 sm:p-6" data-testid="bio-card">
      <div className="flex items-center gap-2 text-amber-400">
        <Crown className="h-5 w-5" fill="currentColor" />
        <span className="font-mono-ui text-[10px] uppercase tracking-[0.25em]">Character Dossier</span>
      </div>

      <h2 className="mt-2 font-royal text-3xl font-extrabold text-white">{bio.name}</h2>
      <p className="font-royal italic text-slate-300">{bio.title}</p>

      <div className="mt-4 rounded-2xl border border-pink-500/20 bg-pink-950/20 p-3">
        <div className="flex items-center gap-2 text-pink-300">
          <Swords className="h-4 w-4" />
          <span className="font-display text-sm font-bold">{bio.signature_move?.name}</span>
        </div>
        <p className="mt-1 text-sm text-slate-300">{bio.signature_move?.desc}</p>
      </div>

      <p className="mt-4 text-sm leading-relaxed text-slate-300">{bio.lore}</p>

      <div className="mt-5 space-y-3">
        {bio.stats?.map((s) => (
          <div key={s.label} data-testid={`stat-${s.label.toLowerCase().replace(/\s+/g, "-")}`}>
            <div className="flex justify-between font-mono-ui text-[11px] uppercase tracking-widest text-slate-400">
              <span>{s.label}</span>
              <span className="text-slate-200">{s.value}</span>
            </div>
            <div className="mt-1 h-2 w-full overflow-hidden rounded-full bg-slate-800">
              <div
                className="h-full rounded-full bg-gradient-to-r from-sky-400 to-amber-400"
                style={{ width: `${s.value}%` }}
              />
            </div>
          </div>
        ))}
      </div>

      <div className="mt-5 flex flex-wrap gap-2">
        <span className="font-mono-ui text-[10px] rounded-full border border-slate-700 px-3 py-1 text-slate-400">
          {bio.character_class}
        </span>
      </div>
    </div>
  );
}
